import Icon from 'veui/components/Icon'
import { IconFlag } from 'dls-icons-vue'

Icon.register('flag', IconFlag)
